import React from 'react'
import WalletView from 'views/XFIWallet'

function Wallet(props) {
  return <WalletView />
}

export default Wallet
